module.exports = "<p>\n\t<b>Orders:</b> - Coming soon in the following update.\n</p>\n"